// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.person-renderer__avatar {
  display: inline;
  vertical-align: bottom;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/feature/user-renderer/PersonRenderer.less"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,sBAAA;AAAJ","sourcesContent":[".person-renderer {\n  &__avatar {\n    display: inline;\n    vertical-align: bottom;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
